import { createPagePagingActions, Table as AdminTable, TableQuery, useTableQuery, useTableQueryPaging } from "@comet/admin";
import { Typography } from "@mui/material";
import { ContentWrapper } from "@src/components";
import { type GQLCamerasFirmwareAdminQuery, type GQLCamerasFirmwareAdminQueryVariables } from "@src/graphql.generated";
import { type FC, type PropsWithChildren } from "react";
import { useIntl } from "react-intl";

import { camerasFirmwareQuery } from "./Table.gql";

const Table: FC<PropsWithChildren> = () => {
    const pagingApi = useTableQueryPaging(1);
    const intl = useIntl();

    const { tableData, loading, error, api } = useTableQuery<GQLCamerasFirmwareAdminQuery, GQLCamerasFirmwareAdminQueryVariables>()(
        camerasFirmwareQuery,
        {
            resolveTableData: ({ camerasFirmwareAdmin }) => ({
                data: camerasFirmwareAdmin.nodes,
                totalCount: camerasFirmwareAdmin.totalCount,
                pagingInfo: createPagePagingActions(pagingApi, camerasFirmwareAdmin),
            }),
            variables: {
                page: pagingApi.current,
            },
        },
    );

    return (
        <ContentWrapper marginVariant="table">
            <TableQuery api={api} loading={loading} error={error}>
                {tableData && (
                    <AdminTable
                        {...tableData}
                        columns={[
                            {
                                name: "name",

                                header: intl.formatMessage({ id: "reviermanager.camera.name", defaultMessage: "Name" }),
                                render: ({ name }) => <Typography>{name}</Typography>,
                            },
                        ]}
                    />
                )}
            </TableQuery>
        </ContentWrapper>
    );
};

export default Table;
